import { render, staticRenderFns } from "./DeviceAverageRatingReviews.vue?vue&type=template&id=6dfdd4b0&scoped=true"
import script from "./DeviceAverageRatingReviews.vue?vue&type=script&lang=js"
export * from "./DeviceAverageRatingReviews.vue?vue&type=script&lang=js"
import style0 from "./DeviceAverageRatingReviews.vue?vue&type=style&index=0&id=6dfdd4b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfdd4b0",
  null
  
)

export default component.exports